import { reactive, onMounted, nextTick, ref } from 'vue'
import { cloneDeep } from 'lodash-es'
import { announcementPublishPermissionConfig } from '@/apis/18782'
import { message } from 'ant-design-vue'
export const useNoticePublishConfig = () => {
  const tableRef = ref(null)
  const state = reactive({
    scrollY: 500,
    editObject: {},
    dataSource: []
  })
  onMounted(() => {
    nextTick(() => {
      state.scrollY = window.innerHeight - 100
    })
  })
  const edit = (record, index) => {
    state.editObject[index] = cloneDeep(record)
  }
  const save = async index => {
    if (!state.editObject[index]?.userId) return message.error('请选择姓名')
    if (![0, 1].includes(state.editObject[index]?.isAdmin))
      return message.error('请选择是否管理员')
    if (!state.editObject[index]?.releaseScopeList?.length)
      return message.error('请选择发布范围')
    const ajax = state.editObject[index].id
      ? announcementPublishPermissionConfig.update_post
      : announcementPublishPermissionConfig.add_post
    const { success, retInfo } = await ajax(state.editObject[index])
    if (success) {
      message.success(retInfo)
      delete state.editObject[index]
      tableRef.value?.refresh()
    } else {
      message.error(retInfo)
    }
  }
  const cancel = index => {
    if (state.editObject[index].id) {
      delete state.editObject[index]
    } else {
      delete state.editObject[index]
      state.dataSource.splice(index, 1)
    }
  }
  const updateStatus = async (record, status) => {
    const ajax =
      status === 0
        ? announcementPublishPermissionConfig.cancellation_post
        : announcementPublishPermissionConfig.take_effect_post
    const { success, retInfo } = await ajax({ id: record.id })
    if (success) {
      message.success(retInfo)
      tableRef.value?.refresh()
    } else {
      message.error(retInfo)
    }
  }
  const add = () => {
    state.dataSource.push({})
    const len = state.dataSource?.length
    state.editObject[len - 1] = {}
  }
  return {
    state,
    edit,
    save,
    cancel,
    tableRef,
    updateStatus,
    add
  }
}
